import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit
} from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../../components_root/rendom_code";
import { Save_cash_books } from "../cash_book_root/save_cash_books";
import { Save_ledger_books } from "../ledger_accounts_root/save_ledger_books";
import { Randomnumber } from "../../components_root/rendom_number";
export const Save_voucher_print = async (data) => {
  const {
    voucher,
    voucher_type,
    voucherid,
    vouchernumber,
    voucherprintid,
    totalamount,
    amount,
    payment_method_online,
    receiptstatus,
  } = data || {};

  // BASIC VALIDATIONS
  if (!voucher || !voucher.trim()) {
    return { success: false, error: "Missing voucher." };
  }

  if (!voucherid || !voucherid.trim()) {
    return { success: false, error: "Missing voucherid." };
  }

  if (!voucherprintid || !voucherprintid.trim()) {
    return { success: false, error: "Missing voucherprintid." };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const select_company_uid = Cookies.get("select_company_uid");

  if (!sessiontoken) {
    return { success: false, error: "Session expired. Please relogin." };
  }
  if (!guid) {
    return { success: false, error: "Login expired. Please relogin." };
  }
  if (!select_company_uid) {
    return { success: false, error: "Contact service provider." };
  }
   const servicetablename = "accountingfinancedb";
  try {
    // SUBCOLLECTION cashier
    const voucherCollection = collection(
      db,
      servicetablename,
      select_company_uid,
      "ledger_accounts_manager"
    );

    // CHECK cashiercashier
    const ledger_accounts_managerQuery = query(
      voucherCollection,
      where("accountguid", "==", guid),
      where("status", "==", true),
      where("voucherid", "==", voucherid)
    );

    const ledger_accounts_managerSnap = await getDocs(ledger_accounts_managerQuery);

    if (ledger_accounts_managerSnap.empty) {
      return { success: false, error: "You are not authorized." };
    }
    //voucher_ledger_accounts_managerQuery


    const ledgerCollection = collection(
      db,
      servicetablename,
      select_company_uid,
      "ledger_accounts_manager"
    );
    const ledgerQuery = query(
      ledgerCollection,
      where("account_type", "==", "master"),
      where("status", "==", true),
      where("voucherid", "==", voucherid)
    );

    const ledgerSnap = await getDocs(ledgerQuery);

    if (ledgerSnap.empty) {
      return { success: false, error: "voucher master account authorized." };
    }

    // Get first document
    const docData = ledgerSnap.docs[0].data();

    // Access field
    const voucheraccountguid = docData.accountguid;

    // SAVE AREA
    const tablename = "voucher_print";
    const voucherprintCollection = collection(
      db,
      servicetablename,
      select_company_uid,
      tablename
    );

    // INDEXNUMBER 
    let tokennumber = 1;
    const lastIndexQuery = query(
      voucherprintCollection,
       where("receiptstatus", "==", true),
      orderBy("date_time", "desc"),
      limit(1)
    );

    // const lastIndexSnap = await getDocs(lastIndexQuery);
    // if (!lastIndexSnap.empty) {
    //   const lastDoc = lastIndexSnap.docs[0].data();
    //   const lastDate = lastDoc.date_time?.toDate();
    //   const lastToken = lastDoc.tokennumber || 0;
    //   const today = new Date();
    //   today.setHours(0, 0, 0, 0);
    //   const lastDateOnly = new Date(lastDate);
    //   lastDateOnly.setHours(0, 0, 0, 0);
    //   // check date
    //   if (lastDateOnly.getTime() === today.getTime()) {
    //     tokennumber = lastToken + 1;    // same day → increment
    //   } else {
    //     tokennumber = 1;                // new day → start at 1
    //   }
    // }
    const lastIndexSnap = await getDocs(lastIndexQuery);
 

if (!lastIndexSnap.empty) {
  const lastDoc = lastIndexSnap.docs[0].data();

  const lastToken = Number(lastDoc.tokennumber || 0);
  const lastDate = lastDoc.date_time?.toDate?.();

  if (lastDate) {
    // 🔹 Today at 12:00 AM
    const todayMidnight = new Date();
    todayMidnight.setHours(0, 0, 0, 0);

    // 🔹 Last token date at 12:00 AM
    const lastDateMidnight = new Date(lastDate);
    lastDateMidnight.setHours(0, 0, 0, 0);

    // 🔁 Same day → increment
    if (lastDateMidnight.getTime() === todayMidnight.getTime()) {
      tokennumber = lastToken + 1;
    } 
    // 🌅 New day → reset
    else {
      tokennumber = 1;
    }
  }
}
    // 3. Get Geo + Device Info from cookies
    const usercity = Cookies.get("city") || "";
    const userpostcode = Cookies.get("postcode") || "";
    const userstate = Cookies.get("state") || "";
    const usercountryname = Cookies.get("country") || "";
    const useraddress = Cookies.get("address") || "";
    const userlatitude = Cookies.get("latitude") || "";
    const userlongitude = Cookies.get("longitude") || "";
    const deviceName = Cookies.get("deviceName") || "Unknown Device";
    //
    const slug = Randomcode(15).toLowerCase();

    const ledgerColitems = collection(
      db,
      servicetablename,
      select_company_uid,
      "ledger_accounts_manager"
    );

    const ledgerQueryitems = query(
      ledgerColitems,
      orderBy("indexnumber", "asc"),
      where("voucherid", "==", voucherid)
    );

    const ledgerSnapitems = await getDocs(ledgerQueryitems);

    // LOOP ALL DOCUMENTS
    const ledgerItems = ledgerSnapitems.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    // FINAL SAVE
    const parentDocRef = doc(
      db,
      servicetablename,
      select_company_uid,
      tablename,
      voucherprintid
    );
    const savequery = {
      ...data,
      tokennumber,
      companyuid: select_company_uid,
      ledger_manager_items: ledgerItems,   // <-- ALL LOOPED ITEMS (field name + field value)
      guid,
      slug, 
      receiptstatus,
      accountguid_authority: guid,
      sessiontoken,
      date_time: new Date(),
      date_time_update: new Date(),
      //
      city: usercity,
      postcode: userpostcode,
      state: userstate,
      country: usercountryname,
      address: useraddress,
      latitude: userlatitude,
      longitude: userlongitude,
      device: navigator.userAgent,
      deviceName,
    };
    await setDoc(parentDocRef, savequery);

// master
  try {
      const Save_ledgerQueryitems = query(
        ledgerColitems,
        where("account_type", "==", "master"), 
        where("voucherid", "==", voucherid)
      ); 
      const Save_ledgerSnapitems = await getDocs(Save_ledgerQueryitems); 
      const Save_ledgerItems = Save_ledgerSnapitems.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      })); 
 
      // Use for...of so we can await inside the loop and keep ordering
      for (const row of Save_ledgerItems) { 
        const val = Number(amount ?? 0) || 0;
        const particulars = voucher + " as Master" ;
 
            await Save_ledger_books({
              accountguid_authority: guid,
              accountguid: row.accountguid,
              particulars,
              tokennumber,
              voucherid: vouchernumber,
              voucher_type,
              credit: val,
              debit: 0
            });
  
      }

      // finished — `running` holds the final balance
    } catch (err) {
      console.error("Error saving ledger items:", err);
      // handle/log UI error as needed
    }


    // Put this inside an async function / handler
    try {
      const Save_ledgerQueryitems = query(
        ledgerColitems,
        where("account_type", "==", "charges"),
        where("ledger_type", "==", "charges"),
        where("voucherid", "==", voucherid)
      );

      const Save_ledgerSnapitems = await getDocs(Save_ledgerQueryitems);

      const Save_ledgerItems = Save_ledgerSnapitems.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      let running = Number(amount || 0);

      // Use for...of so we can await inside the loop and keep ordering
      for (const row of Save_ledgerItems) {
        // defensive defaults
        const opRaw = (row?.manageacalc ?? "+").toString().trim();
        const op = opRaw === "-" ? "-" : "+"; // only support "-" or "+"
        const modeRaw = (row?.mathedcalc ?? "=").toString().trim();
        const mode = modeRaw === "%" ? "%" : "="; // support "%" or "="
        const val = Number(row?.amount ?? 0) || 0;
        const particulars = voucher + " as " + row.managename + ", " + row.manageacalc + " " + row.amount + "" + row.mathedcalc;

        if (mode === "%") {
          const delta = (running * val) / 100;

          if (op === "-") {
            await Save_ledger_books({
              accountguid_authority: guid,
              accountguid: row.accountguid,
              particulars,
              tokennumber,
              voucherid: vouchernumber,
              voucher_type,
              credit: 0,
              debit: delta
            });

          } else {
            await Save_ledger_books({
              accountguid_authority: guid,
              accountguid: row.accountguid,
              particulars,
              tokennumber,
              voucherid: vouchernumber,
              voucher_type,
              credit: delta,
              debit: 0
            });

          }
        } else {
          // absolute value
          if (op === "-") {
            await Save_ledger_books({
              accountguid_authority: guid,
              accountguid: row.accountguid,
              particulars,
              tokennumber,
              voucherid: vouchernumber,
              voucher_type,
              credit: 0,
              debit: val
            });

          } else {
            await Save_ledger_books({
              accountguid_authority: guid,
              accountguid: row.accountguid,
              particulars,
              tokennumber,
              voucherid: vouchernumber,
              voucher_type,
              credit: val,
              debit: 0
            });

          }
        }
      }

      // finished — `running` holds the final balance
    } catch (err) {
      console.error("Error saving ledger items:", err);
      // handle/log UI error as needed
    }




    //Save_cash_books 
    //voucher accountguid
    if (payment_method_online == true) {
      //  Save_ledger_books({accountguid_authority:guid,accountguid:voucheraccountguid,particulars:voucher,tokennumber,voucherid:voucherprintid,voucher_type,credit:totalamount,debit:0});
    } else {
      Save_cash_books({ accountguid_authority: guid, accountguid: guid, particulars: voucher, tokennumber, voucherid: vouchernumber,voucher_type, credit: totalamount, debit: 0 });
    }

    return { success: true, message: "Voucher saved successfully." };
  } catch (err) {
    console.error("Error saving voucher:", err);
    return { success: false, error: err?.message || "Unknown error" };
  }
};
